import { ResponsivePopover } from "@components/ui/ResponsivePopover"
import { FILM_FILTERS, FilmFilter, FilmFilterKey } from "./program-filters"
import { FilmSearch } from "./useFilmSearch"
import { ReactElement, useEffect, useState } from "react"
import { Command } from "cmdk"
import { Drawer } from "@components/ui/Drawer"
import { Button } from "@components/ui/Button"

type Props = {
  browse: FilmSearch
  filterKey: FilmFilterKey
  trigger: ReactElement
  resetLabel?: string
}

export function ProgramFilterPopup(props: Props) {
  const filter = FILM_FILTERS[props.filterKey]

  const realValue = props.browse.filters.get(props.filterKey)

  const [value, setValue] = useState(realValue)

  useEffect(() => {
    setValue(realValue)
  }, [realValue])

  return (
    <ResponsivePopover
      popover={{
        side: "bottom",
        align: "start",
        padded: false,
      }}
      drawer={{
        handle: true,
        padded: false,
      }}
      trigger={props.trigger}
    >
      {({ close, as }) => (
        <Command>
          {as === "drawer" && (
            <Drawer.Title className="px-6 type-title-l pt-4 pb-5 border-b border-bg-mid">{filter.name}</Drawer.Title>
          )}
          <FilmFilter<any> browse={props.browse} filterKey={props.filterKey} store={{ value, setValue }} />
          <div className="border-t border-bg-mid flex items-center justify-evenly px-6 py-4 gap-4 md:px-3 md:py-3 md:gap-2">
            <Button
              className="flex-1"
              variant="outline"
              onClick={() => {
                setValue(filter.getDefault())
                props.browse.filters.set(props.filterKey, undefined as any)
                close()
              }}
            >
              {props.resetLabel ?? "Clear All"}
            </Button>
            <Button
              className="flex-1"
              variant="primary"
              onClick={() => {
                props.browse.filters.set(props.filterKey, value as any)
                close()
              }}
            >
              Apply
            </Button>
          </div>
        </Command>
      )}
    </ResponsivePopover>
  )
}
